import { Component } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AboutUsProvinceOption, AboutUsService } from 'src/app/services/about-us.service';
import { AuthService } from 'src/app/services/auth.service';
import { Provinces } from 'src/app/components/global/province';
import { ParticipantThemeService } from 'src/app/services/participant-theme.service';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
    selector: 'app-about-us',
    templateUrl: './about-us.component.html',
    styleUrls: ['./about-us.component.scss'],
    standalone: false
})
export class AboutUsComponent {
  participantClassByRole: string = '';
  bannerClass: string = '';
  translations: any;
  llttfPage:boolean = false;
  content: SafeHtml | null = null;
  isLoggedIn = false;
  provinceOptions: AboutUsProvinceOption[] = [];
  selectedProvinceId: Provinces = Provinces.BritishColumbia;

  constructor(
    public translationService :TranslationService,
    public themeService :ParticipantThemeService,
    private aboutusservice:AboutUsService,
    private sanitizer:DomSanitizer,
    private authservice: AuthService
  ) { }

  ngOnInit()
  {
    this.isLoggedIn = !!this.authservice.checkTokenExpiry();
    this.provinceOptions = this.aboutusservice.publicProvinceOptions;

    this.themeService.setParticipantTheme();
    this.participantClassByRole = this.themeService.participantClassByRole;
    this.llttfPage = this.themeService.llttfPage;
    this.bannerClass = this.getBannerClass();

    this.translationService.getTranslation().subscribe({
      next: (translations) => {
        this.translations = translations;
        this.updateContent();
      }
    });
  }

  selectProvince(provinceId: Provinces): void {
    this.selectedProvinceId = provinceId;
    this.updateContent();
  }

  isSelectedProvince(provinceId: Provinces): boolean {
    return this.selectedProvinceId === provinceId;
  }

  private updateContent(): void {
    if (!this.translations) {
      return;
    }

    const key = this.isLoggedIn
      ? this.aboutusservice.getAboutUsContentTranslationKey()
      : this.aboutusservice.getContentTranslationKeyForProvince(this.selectedProvinceId);

    const html = key ? (this.translations[key] as string) ?? '' : '';
    this.content = html ? this.sanitizer.bypassSecurityTrustHtml(html) : null;
  }

  private getBannerClass(): string {
    if (!this.isLoggedIn) {
      return '';
    }

    if (!this.authservice.getUserLoginData().isParticipant) {
      return 'bb-coached-color';
    }

    return this.participantClassByRole;
  }
}
